import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { ModalCloseButtonComponent } from '../modal-close-button/modal-close-button.component';

@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.scss'],
  imports: [
    MatDialogModule,
    MatIconModule,
    CommonModule,
    ModalCloseButtonComponent,
  ],
})
export class ConfirmationModalComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      message: string;
      closable: boolean;
      showIcon: boolean;
      buttons?: {
        text: string;
        id: number;
        color: string;
        action?: () => void;
        closeDialog?: boolean;
      }[];
    },
    private dialogRef: MatDialogRef<ConfirmationModalComponent>
  ) {
    this.data.showIcon = this.data.showIcon ?? true;
  }

  performAction(id: number) {
    this.data.buttons[id].action();
    this.closeDialog(true);
  }

  closeDialog(value: boolean = false) {
    this.dialogRef.close(value);
  }
}
